// import React from 'react';
import Card from 'react-bootstrap/Card';
import '../bottomComponents.css';
import  Recipe_top from './recipe_top.png'
import Badge from 'react-bootstrap/Badge';
import { BsGithub } from 'react-icons/bs';
import { FaVimeo } from 'react-icons/fa';

function ProjectRecipe() {
  return (
    <div class="project">
    <Card style={{ width: '23rem' }}>

      <Card.Body>
      <Card.Title className="text-center">Recipe Planner</Card.Title>
      <img src={Recipe_top} />
  
      <div class="badge-container">
        <Badge bg="primary">
        Java
      </Badge>{' '}
      <Badge bg="primary">
        JavaScript
      </Badge>{' '}
      <Badge bg="primary">
        H2 db
      </Badge>{' '}
      <Badge bg="danger">
        React
      </Badge>{' '}
      <Badge bg="danger">
        Spring
      </Badge>{' '}
      <Badge bg="danger">
        Agile
      </Badge>{' '}
      <Badge bg="danger">
        TDD
      </Badge>{' '}
      <Badge bg="secondary">
        Group Project
      </Badge>{' '}
      </div>
      <Card.Text class="project-text">
       This is a multi functional app created by amazing teamwork. The app lets users
       search recipes by ingredients, cuisine and diet type. Authenticated users can: <br/>
      - Access their dashboard.<br/>
      - Input and edit meal plans on monthly calendar.<br/>
      - Edit shopping cart generated by their meal plans.<br/>
      - Leave comments on each recipe page.  <br/>
        </Card.Text>
        <div class="repo-container">
        <Card.Link class="github-link-sm" href="https://github.com/taksgarby/Recipe_Generator_Back_End" target="_blank">
        <BsGithub /> Backend Repo</Card.Link>
        <Card.Link class="github-link-sm" href="https://github.com/taksgarby/Recipe_Generator_FrontEnd" target="_blank">
        <BsGithub /> Frontend Repo</Card.Link>

   
        </div>
      <div class="video-link">
        <a href="https://vimeo.com/user196699763" target="_blank">
          <FaVimeo/>Watch our presentation
        </a>
      </div>
    
      </Card.Body>
    </Card>
    </div>
  );
}

export default ProjectRecipe;



